<template>
    <div id="provider">
        <div id="webcam"></div>
        <div class="ui fluid container">
            <div v-if="$store.state.is_login === true" class="ui stackable grid">
                <div class="three wide column"
                    v-if="$store.getters['provider/is_current_staff_minimalist_layout']">
                    <Sidebar v-if="$store.state.initialize_statuses.service_theme"></Sidebar>
                    <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/sidebar.png" alt="">
                </div>

                <div class="thirteen wide column"
                    v-bind:class="{centered: !$store.getters['provider/is_current_staff_minimalist_layout']}">
                    <TopMenu v-if="$store.state.initialize_statuses.top_menu"></TopMenu>
                    <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/top_menu.png" alt="">

                    <Breadcrumb v-if="$store.state.initialize_statuses.main"></Breadcrumb>
                    <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/breadcrumb.png" alt="">

                    <div class="ui main" style="min-height: calc(100vh - 250px);">
                        <router-view v-if="$store.state.initialize_statuses.main"></router-view>
                        <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/main.png" alt="">
                    </div>

                    <div class="clear"></div>
                    <FooterBar v-if="$store.state.initialize_statuses.footer"></FooterBar>
                    <img v-else class="loading_mock opacity_fade" src="/images/loading_darken/footer.png" alt="">
                    <Advertising></Advertising>
                    <SystemInfo></SystemInfo>
                </div>

                <StationsModal v-if="$store.state.initialize_statuses.main"></StationsModal>
                <DatetimerangeModal v-if="$store.state.initialize_statuses.main"
                    :options="$store.state.element_ui_datepicker_daterange_options.shortcuts"
                    :channel="date_picker_modal.channel"
                    :type="date_picker_modal.type"
                ></DatetimerangeModal>

                <ScannerModal v-if="$store.state.initialize_statuses.main"></ScannerModal>
                <!-- <div v-else class="ui dimmer transition visible active" style="display: block !important;">
                    <div class="ui text loader">{{ $t('ui.general.initializing') }}</div>
                </div> -->
            </div>
            <div v-else-if="$store.state.is_login === false">
                <div class="ui container">
                    <Login></Login>
                    <FooterBar></FooterBar>
                </div>
            </div>
            <div v-else class="ui inverted dimmer transition visible active" style="display: block !important;">
                <div class="ui text loader">
                    <!-- 驗證身份... -->
                    {{ $t('ui.general.verify_staff') }}...
                </div>
            </div>
        </div>
        <div class="ui basic modal" ref="login_expiration_hint_modal">
            <div class="ui icon header">
                <i class="wait icon"></i>
                <!-- 閒置 -->
                {{ $t('ui.pages.partials.login_expiration_hint_modal.idle') }}
            </div>
            <div class="content" style="color: white;">
                <p>
                    <!-- 系統偵測到你很久沒有動作了，再過{{ human_remaining_time }}就會自動登出。 -->
                    {{
                        $t('ui.pages.partials.login_expiration_hint_modal.content', {
                            time: human_remaining_time
                        })
                    }}
                </p>
            </div>
            <div class="actions">
                <div class="ui green ok inverted button" @click="extend_login_timeout">
                    <i class="checkmark icon"></i>
                    <!-- 我回來了 -->
                    {{ $t('ui.pages.partials.login_expiration_hint_modal.i_am_back') }}
                </div>
            </div>
        </div>

        <div
            v-if="$store.state.is_login && $store.state.provider.is_can_use_scanner"
            @click="$bus.$emit('toggle_scanner_modal')"
            :class="{hide: is_hide_icon_toggle_scanner_modal}"
            class="icon_toggle_scanner_modal pointer mobile only">
            <i class="large circular inverted icon z-depth-2"
            :class="{
                'barcode': !is_scanner_modal_opend,
                'red remove': is_scanner_modal_opend,
            }">
            </i>
        </div>

    </div>
</template>

<script>
import Sidebar from '@partials/provider/sidebar.vue'
import TopMenu from '@partials/provider/top_menu.vue'
import FooterBar from '@partials/provider/footer_bar.vue'
import Advertising from '@partials/provider/advertising.vue'
import SystemInfo from '@partials/provider/system_info.vue'
import Breadcrumb from '@partials/provider/breadcrumb.vue'
import ScannerModal from '@scanner/provider/modal.vue'
import StationsModal from '@toolbox/stations_modal/main.vue'
import DatetimerangeModal from '@toolbox/date_picker_modal/main.vue'
import Login from '@login/provider_main.vue'
import Keyboard from '@javascripts/keyboard.js'
import WebCamera from 'webcamjs'

var login_validation_timer;
var login_timeout_hint_timer;
var PointInside = require('@javascripts/point_inside.js');

export default {
    name: "ProviderLayout",
    data () {
        return {
            clock: {
                ticker: null,
                remaining_time: 0,
            },
            selected_plan: 0,
            action_cables: [],
            is_hide_icon_toggle_scanner_modal: false,
            is_scanner_modal_opend: false,
            date_picker_modal: {
                channel: "",
                type: ""
            },
            // for Honeywell android 7
            is_phone_device: false,
            phone_device_unidentified_count: 0,
            websock_server: null,
            data_uri: ""
        }
    },
    computed: {
        build_env() {
            return ENV.VUE_APP_BUILD_ENV
        },
        language() {
            return this.$store.state.language
        },
        human_remaining_time() {
            var moment = this.$moment
            var eventMDuration = moment.duration(Math.floor(this.clock.remaining_time / 1000), "seconds")
            var eventDurationString = ""
            if (eventMDuration.days() > 0)
                eventDurationString += " " + eventMDuration.days() + this.$t('ui.general.day')
            if (eventMDuration.hours() > 0)
                eventDurationString += " " + eventMDuration.hours() + this.$t('ui.general.hour')
            if (eventMDuration.minutes() > 0)
                eventDurationString += " " + eventMDuration.minutes() + this.$t('ui.general.minute')
            if (eventMDuration.seconds() > 0)
                eventDurationString += " " + eventMDuration.seconds() + this.$t('ui.general.second')

            return eventDurationString.trim()
        },
        // for partial/permission_denied use
        back_two_page() {
            return this.$store.state.back_two_page
        },
        current_store() {
            return this.$store.state.provider
        },
    },
    async created() {
        if (this.build_env == 'electron') {
            this.websock_server = new WebSocket('ws://127.0.0.1:8899/weight')

            this.websock_server.onmessage = (messgae) => {
                console.log("message: ", messgae)
                this.$store.commit('provider/scanner_module/set_current_weight', parseFloat(messgae.data))
                return false
            }
            this.websock_server.onclose = () => {
                console.log("WebSocket on weight disconnect")
            }
            this.websock_server.onopen = () => {
                console.log("WebSocket on weight opened")
            }
            this.websock_server.onerror = (error) => {
                console.log("WebSocket on weight error")
            }
        }

        await this.init()

        this.back_two_page.unshift(this.$route)

        document.title = this.$t('ui.page_titles.' + this.$route.name) + " | Neuron"
        this.toggle_scanner_modal_keyboard_shortcut()
    },
    mounted() {
        this.$bus.$off("toggle_scanner_modal")
        this.$bus.$on("toggle_scanner_modal", (value = "toggle") => {
            this.toggle_scanner_modal(value)
        })

        this.$bus.$off("toggle_station_modal")
        this.$bus.$on("toggle_station_modal", (value = "toggle") => {
            this.toggle_station_modal(value)
        })

        this.$bus.$off("date_picker_modal")
        this.$bus.$on("date_picker_modal", (value = "toggle", type="daterange", channel = "") => {
            this.date_picker_modal = {
                channel: channel,
                type: type,
            }
            this.toggle_date_picker_modal(value)
        })

        this.$bus.$off("toggle_scanner_modal_keyboard_shortcut")
        this.$bus.$on("toggle_scanner_modal_keyboard_shortcut", () => {
            this.toggle_scanner_modal_keyboard_shortcut()
        })

        this.$bus.$off("toggle_is_hide_icon_toggle_scanner_modal")
        this.$bus.$on("toggle_is_hide_icon_toggle_scanner_modal", (value = false) => {
            this.toggle_is_hide_icon_toggle_scanner_modal(value)
        })

        this.$bus.$off("is_print_waybill")
        this.$bus.$on("is_print_waybill", (
            core_waybill_number,
            event_bus_name = "", // 雙向 event_bus
            max_diff_second = 1, //重複號碼秒數上限, 預設60s
            max_length = 10 //最多號碼數量, 預設10筆
        ) => {
            var result = this.is_print_waybill(
                core_waybill_number,
                max_diff_second,
                max_length
            )

            if (event_bus_name) {
                this.$bus.$emit(event_bus_name, result)
            } else {
                if (result.error) {
                    alert(result.error)
                }
            }

        })

        this.$store.state.style.width = $(window).width()
        this.$store.state.style.height = $(window).height()
        $(window).resize(() => {
            this.$store.state.style.width = $(window).width()
            this.$store.state.style.height = $(window).height()
        })
    },
    beforeDestroy() {
        this.websock_server.close()
    },
    watch: {
        '$route' (to, from) {
            console.log("provider Layout watch")
            if (to.name != 'settings') {
                this.check_current_station()
            }
            // 當route變動時重設登入逾時時間
            this.extend_login_timeout()

            // Page Title
            document.title = this.$t('ui.page_titles.' + to.name) + " | Neuron"

            // for partial/permission_denied
            this.back_two_page.unshift(from)
            this.back_two_page.length = 2
        },
        // 處理在store無法切換i18n的文字
        'language': {
            handler(value) {
                try {
                    this._i18n.locale = value
                    this.cahnge_language_in_store_js_text()
                    // console.log(this.$route.name)
                    document.title = this.$t('ui.page_titles.' + this.$route.name) + " | Neuron"
                } catch (e) {
                    console.log(e)
                    this.$noty.error(e)
                }
            },
            deep: true,
        },
        'current_store.is_auto_gps_station_position_once': {
            async handler(value) {
                try {
                    if (value) {
                        await this.get_current_position()
                        await this.set_station_position()
                        await this.$store.dispatch('provider/fetch_current_position_address')
                        await new Promise(resolve => {
                            this.$store.state.is_auto_gps_station_position_once = false
                            resolve()
                        })
                        this.$noty.information(
                            // "開啟gps，自動偵測站點(一次)"
                            $t('ui.toolbox.stations_modal.turn_on_GPS') + '，'+
                            $t('ui.toolbox.stations_modal.btns.track_once')
                        )
                    }
                } catch (e) {
                    this.$store.state.is_auto_gps_station_position_once = false
                    console.log(e)
                }
            },
            deep: true,
        },
        'current_store.is_auto_gps_station_position_by_60s': {
            handler(value) {
                localStorage.setItem('is_auto_gps_station_position_by_60s', value)
                this.set_interval_gps_station_position()

                if (value) {
                    this.$noty.information(
                        // "開啟gps，每分鐘自動偵測站點"
                        this.$t('ui.toolbox.stations_modal.turn_on_GPS') + '，'+
                        this.$t('ui.toolbox.stations_modal.btns.auto_tracking_every_minute')
                    )
                    this.get_current_position()
                    this.set_station_position()
                } else {
                    this.$noty.warning(
                        // '關閉 每分鐘偵測站點'
                        this.$t('ui.toolbox.stations_modal.turn_of_GPS') + '，'+
                        this.$t('ui.toolbox.stations_modal.btns.auto_tracking_every_minute')
                    )
                }
            },
            deep: true,
        },
    },
    methods: {
        snap() {
            WebCamera.snap(data_uri => {
                this.data_uri = data_uri
            })
        },
        wait(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
        },
        async init() {
            try {
                await new Promise(resolve => {
                    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"

                    let instance_identity = ""
                    for (let i = 0; i < 16; i++) {
                        instance_identity += possible.charAt(Math.floor(Math.random() * possible.length))
                    }
                    console.log(instance_identity)
                    this.$store.state.instance_identity = instance_identity
                    resolve()
                })
                await new Promise(resolve => {
                    var reslut = localStorage.getItem("language") || 'zh-TW'
                    this.$store.state.language = reslut
                    resolve()
                })
                await new Promise(resolve => {
                    this.$store.commit('set_current_scope', 'provider')
                    resolve()
                })
                await new Promise(resolve => {
                    var is_phone_device = navigator.userAgent.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile/i)
                    this.is_phone_device = is_phone_device ? true : false
                    resolve()
                })
                await this.validate_login()
                await new Promise(resolve => {
                    this.$store.state.is_login = true
                    resolve()
                })
                await new Promise(resolve => {
                    // 檢測使用者點擊滑鼠或鍵盤操作時重置逾時
                    $(document).mousedown((event) => {
                        this.extend_login_timeout()
                    })
                    $(document).keydown((event) => {
                        this.extend_login_timeout()
                    })
                    // 每秒做一次登入逾時倒數
                    this.clock.ticker = setInterval(() => {
                        this.login_expiration_countdown()
                    }, 1000)
                    resolve()
                })
                await new Promise(resolve => {
                    this.action_cables.forEach((action_cable) => {
                        action_cable.unsubscribe()
                    })
                    this.action_cables = []
                    resolve()
                })
                await this.subscription()
                await this.$store.dispatch('provider/fetch_routes')
                await this.$store.dispatch('provider/fetch_node')
                await this.$store.dispatch('provider/fetch_stations')
                await this.$store.dispatch('provider/fetch_customers')
                await this.$store.dispatch('provider/fetch_current_staff')
                await this.$store.dispatch('provider/fetch_current_staff_operations')
                await this.$store.dispatch('provider/fetch_notifications')
                await this.$store.dispatch('provider/fetch_papers_label_infos')
                await new Promise(resolve => {
                    this.$cable.subscriptions.create(
                        {
                            channel: 'StaffChannel',
                            staff_identity: this.$store.state.provider.current_staff.identity,
                        },
                        {
                            connected() {
                                console.log("StaffChannel connected")
                            },
                            received(response) {
                                console.log(response)
                            }
                        }
                    )
                    resolve()
                })
                await this.setting_service_and_user_theme()
                await this.setting_is_can_use_top_menu_items()
                await new Promise(resolve => {
                    this.current_store.is_auto_gps_station_position_by_60s =
                    (localStorage.getItem('is_auto_gps_station_position_by_60s') == 'true')
                        ? true
                        : false
                    resolve()
                })
                await this.wait(300 * this.selected_plan)
                await new Promise(resolve => {
                    this.$store.state.initialize_statuses.top_menu = true
                    resolve()
                })
                await new Promise(resolve => {
                    this.$store.state.initialize_statuses.service_theme = true
                    resolve()
                })
                await this.wait(200 * this.selected_plan)
                await this.check_staff_is_manager()
                await this.check_current_station()
                await this.set_current_staff_operation()
                await this.wait(400 * this.selected_plan)
                await new Promise(resolve => {
                    this.$store.state.initialize_statuses.sidebar = true
                    resolve()
                })
                await this.wait(100 * this.selected_plan)
                await new Promise(resolve => {
                    this.$noty.information(this.$t('ui.general.initialize_complete'), 300)
                    this.$store.state.initialize_statuses.main = true
                    this.$store.state.initialize_statuses.footer = true
                    resolve()
                })
                /*
                 * Current Page
                 */
            } catch (e) {
                switch (e) {
                    default:
                }
            } finally {
            }
        },
        subscription() {
            this.action_cables.push(
                this.$cable.subscriptions.create(
                    {
                        channel: 'RemoteControlChannel',
                    },
                    {
                    received: (data) => {
                        // console.log('[' + data.log.level + ']' + data.log.title + '-' + data.log.loggable_type)
                        eval(data.script)
                    }
                })
            )
            // LogChannel#created
            this.action_cables.push(
                this.$cable.subscriptions.create(
                    {
                        channel: 'LogChannel',
                        action: 'created'
                    },
                    {
                    received: (data) => {
                        console.log('[' + data.log.level + ']' + data.log.title + '-' + data.log.loggable_type)
                    }
                })
            )
            // OperationChannel#created
            this.action_cables.push(
                this.$cable.subscriptions.create(
                    {
                        channel: 'OperationChannel',
                        action: 'created'
                    },
                    {
                        received: (data) => {
                            console.log("OperationChannel#created")
                            this.$store.state.operations.push(data.operation)
                        }
                    }
                )
            )
            // OperationChannel#updated
            this.action_cables.push(
                this.$cable.subscriptions.create(
                    {
                        channel: 'OperationChannel',
                        action: 'updated'
                    },
                    {
                        received: (data) => {
                            console.log("OperationChannel#updated")
                            var target_operation = _.findLast(this.$store.state.operations, (operation) => {
                                return operation.identity == data.operation.identity
                            })
                            _.merge(target_operation, data.operation)
                        }
                    }
                )
            )
            // CoreWaybillChannel#created
            this.action_cables.push(
                this.$cable.subscriptions.create(
                    {
                        channel: 'CoreWaybillChannel',
                        action: 'created'
                    },
                    {
                        received: (data) => {
                            console.log("CoreWaybillChannel#created")
                            this.$store.state.core_waybills.push(data.core_waybill)
                        }
                    }
                )
            )
            // CoreWaybillChannel#updated
            this.action_cables.push(
                this.$cable.subscriptions.create(
                    {
                        channel: 'CoreWaybillChannel',
                        action: 'updated'
                    },
                    {
                        received: (data) => {
                            console.log("CoreWaybillChannel#updated")
                            var target_core_waybill = _.findLast(this.$store.state.core_waybills, (core_waybill) => {
                                return core_waybill.identity == data.core_waybill.identity
                            })
                            _.merge(target_core_waybill, data.core_waybill)
                        }
                    }
                )
            )
            return Promise.resolve()
        },
        setting_service_and_user_theme() {
            var console_log_content = "", file_name, file
            var service_name = this.$store.state.provider.node.service_name
            var user_theme_name = this.$store.state.provider.current_staff.theme_name

            try {
                file_name = service_name + "/config.json"
                file = require("../../config/services/" + file_name)
            } catch (e) {
                // not find file
                file_name = "default/config.json"
                file = require("../../config/services/" + file_name)
            } finally {
                // 捲軸樣式
                document.body.classList.add(service_name)
                this.$store.state.provider.service_config = file
                console_log_content += "    service: " + file_name + "\n"
            }

            try {
                file_name = service_name + "/user_menu.json"
                file = require("../../config/services/" + file_name)
            } catch (e) {
                // not find file
                file_name = "default/user_menu.json"
                file = require("../../config/services/" + file_name)
            } finally {
                this.$store.state.provider.theme_menu = file[user_theme_name]
                this.$store.state.provider.theme_menu_keys = Object.keys(file)
                console_log_content += "    user theme: " + file_name + "\n"
            }

            console.log(
                "//=============== \n" +
                "  Now service&theme configs: \n" +
                    console_log_content +
                "  All file path: config/services/ \n" +
                "//=============== \n"
            )

            return Promise.resolve()
        },
        setting_is_can_use_top_menu_items() {
            var store_name, result, items = ["scanner"]

            _.forEach(items, (item) => {
                result = _.findLast(this.$store.state.provider.theme_menu, (menu_name) => {
                    return menu_name == item
                })
                store_name = "is_can_use_" + item
                this.$store.state.provider[store_name] = (result) ? true : false
            })
            return Promise.resolve()
        },
        check_staff_is_manager() {
            if (!this.$store.getters['provider/is_current_staff_minimalist_layout']) {
                this.$router.push({name: 'provider_index'})
            }
            return Promise.resolve()
        },
        check_current_station() {
            if (
                !this.$store.state.provider.current_staff.station_identity &&
                !this.$store.getters['provider/is_current_staff_minimalist_layout']
            ) {
                localStorage.setItem('target_router_name', this.$route.name)
                // 請先設置當前站點
                this.$noty.warning(
                    this.$t('ui.toolbox.stations_modal.please_select_the_current_station')
                )

                this.toggle_station_modal('show')
            }
            return Promise.resolve()
        },
        set_current_staff_operation() {
            // 原本是寫在getter內
            // 但判定點存在localStorage 內
            // getter不會自動更新
            this.$store.state.provider.current_staff_operation = _.findLast(
                this.$store.state.provider.current_staff_operations,
                (operation) => {
                    return operation.number == localStorage.getItem("current_staff_operations_number")
                }
            ) || {
                identity: null,
                number: null,
            }

            return Promise.resolve()
        },
        set_interval_gps_station_position() {
            if (this.current_store.is_auto_gps_station_position_by_60s) {
                var auto_gps_station_position = setInterval(() => {
                    if (this.current_store.current_position.is_first_initialized) {
                        this.get_current_position()
                        this.set_station_position()
                    }
                }, 60*1000)

            } else {
                if (auto_gps_station_position) {
                    clearInterval(auto_gps_station_position)
                    this.current_store.current_position.is_first_initialized = false
                }
            }
        },
        set_station_position() {
            _.forEach(this.current_store.stations, (station) => {
                if (station.position) {
                    if (PointInside(
                        [
                            // 25.0795308, 121.237088
                            this.current_store.current_position.latitude,
                            this.current_store.current_position.longitude,
                        ],
                        $.parseJSON(station.position)
                    )) {
                        try {
                            console.log("符合站點為:", station.name, station)
                            if (this.$store.getters['provider/current_station'].identity != station.identity) {
                                this.$store.dispatch('provider/update_current_staff_station_identity', station)
                                // this.$noty.success('更新站點為：'+station.name)
                                this.$noty.success(
                                    this.$t('ui.notifications.success.update__name', {
                                        name: this.$t('models.stations'),
                                        reason: ':' + station.name
                                    })
                                )
                            }
                        } catch (e) {
                            // this.$noty.error('無法更新站點')
                            this.$noty.error(
                                this.$t('ui.notifications.error.update__name', {
                                    name: this.$t('models.stations')
                                })
                            )
                        }
                    }
                }
            })
        },
        validate_login() {
            if (localStorage.getItem("authentication_token")) {
                // 已經登入
                if (localStorage.getItem("staff_expired_at") > this.$moment.utc().format()) {
                    // 登入尚未逾時
                    var url = this.$store.state.settings.authorize_url
                    return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                        .then(response => {
                            if (response.data.status == "success") {
                                this.extend_login_timeout()
                                return Promise.resolve()
                            } else {
                                return Promise.reject(response.data)
                            }
                        })
                        .catch(error => {
                            if (error.response) {
                                switch (error.response.status) {
                                    default:
                                    this.errors.push(error.response.status + ' ' + error.response.statusText)
                                }
                                // this.$noty.error("登入失敗: " + error.response.status + ' ' + error.response.statusText)
                                this.$noty.error(
                                    this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                                    error.response.status + ' ' + error.response.statusText
                                )
                            } else if (error.errors) {
                                for (var message in error.errors) {
                                    this.$noty.error(
                                        this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                                        message + " " + error.errors[message]
                                    )
                                }
                            } else {
                                this.$noty.error(
                                    this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                                    this.$t('ui.general.server_offline')
                                );
                            }
                            this.clear_login_session();
                            this.$store.state.is_login = false
                            return Promise.reject("authorize failed")
                        })
                } else {
                    // 登入逾時
                    // this.$noty.error("登入失敗: 閒置過久已自動登出")
                    this.$noty.error(
                        this.$t('ui.pages.login.errors.failure_to_login') + ': ' +
                        this.$t('ui.pages.login.errors.timeout')
                    )

                    this.$store.state.is_login = false

                    if (this.$store.state.initialize_statuses.main) {
                        $(this.$refs.login_expiration_hint_modal).modal('hide')
                        this.logout()
                    } else {
                        this.clear_login_session()
                        return Promise.reject("login timeout")
                    }
                }
            } else {
                // 尚未登入
                this.$store.state.is_login = false
                return Promise.reject("not logged in")
            }
        },
        login_expiration_countdown() {
            this.clock.remaining_time = this.clock.remaining_time - 1000
            if (this.clock.remaining_time < 1000) {
                this.validate_login()
            }
            if ( this.clock.remaining_time < this.$store.state.global_setting.login_expiration_hint_preset*1000) {
                this.show_login_timeout_hint()
            }
        },
        show_login_timeout_hint() {
            var that = this
            $(this.$refs.login_expiration_hint_modal)
                .modal({
                    closable: false,
                    onShow(){
                        that.is_hide_icon_toggle_scanner_modal = true
                        $('.ui.dimmer.modals').css("background", "rgba(0,0,0,0.85)")
                    },
                    onHidden(){
                        that.is_hide_icon_toggle_scanner_modal = false
                    },

                })
                .modal('show')
        },
        extend_login_timeout() {
            localStorage.setItem("staff_expired_at", this.$moment.utc(this.$moment().add(this.$store.state.global_setting.login_expiration_period, 'second')).format())
            this.clock.remaining_time = this.$store.state.global_setting.login_expiration_period*1000
            $(this.$refs.login_expiration_hint_modal).modal('hide')
        },
        clear_login_session() {
            clearTimeout(login_validation_timer)
            clearTimeout(login_timeout_hint_timer)
            localStorage.removeItem("staff_name")
            localStorage.removeItem("staff_expired_at")
            localStorage.removeItem("authentication_token")
        },
        redirect_to(path) {
            window.location.replace(path)
        },
        logout(is_remove_all_local_storage = false) {
            this.clear_login_session()
            if (is_remove_all_local_storage == true) {
                localStorage.clear()
            }

            if (ENV.VUE_APP_BUILD_ENV == 'electron') {
                this.init()
            } else {
                this.redirect_to('/provider')
            }
        },
        window_keydown(e) {
            var keyboard = new Keyboard(e)

            // for Honeywell android 7
            // console.log(keyboard.key)
            // if (this.is_phone_device && keyboard.key == 'Unidentified') {
            //     console.log('yes!!!!!!!!!!!!!!!!')
            //     this.phone_device_unidentified_count += 1
            //     if (this.phone_device_unidentified_count >= 2) {
            //         this.toggle_scanner_modal("toggle")
            //         this.phone_device_unidentified_count = 0
            //     }
            //     setTimeout(function() {
            //         console.log('Clear phone_device_unidentified_count!')
            //         this.phone_device_unidentified_count = 0
            //     }, 500)
            // }

            // ctrl + Q
            if ((keyboard.key_code == 81 && keyboard.ctrl) || keyboard.key == "WakeUp") {
                this.toggle_scanner_modal("toggle")
            }
        },
        toggle_is_hide_icon_toggle_scanner_modal(value = false) {
            this.is_hide_icon_toggle_scanner_modal = value
        },
        toggle_scanner_modal_keyboard_shortcut() {
            // $(window).bind("keydown", this.window_keydown)
            $(window).bind("keyup", this.window_keydown)
        },
        toggle_scanner_modal(value = "toggle") {
            var that = this
            if (this.$store.state.provider.is_can_use_scanner) {
                $('.ui.scanner.modal')
                    .modal({
                        dimmerSettings: {opacity: 0},
                        autofocus: false,
                        inverted: true,
                        duration: 200,
                        onShow(){
                            that.is_scanner_modal_opend = true
                            that.$bus.$emit('set_modal_opened', true)
                        },
                        onHidden(){
                            that.is_scanner_modal_opend = false
                            that.$bus.$emit('set_modal_opened', false)
                        },
                    })
                    .modal(value)
            }
        },
        toggle_station_modal(value = "toggle") {
            var that = this
            $('.ui.modal.stations')
                .modal({
                    closable: false,
                    autofocus: false,
                    onShow(){
                        that.is_hide_icon_toggle_scanner_modal = true
                        $('.ui.dimmer.modals').css("background", "rgba(0,0,0,0.85)")
                    },
                    onHidden(){
                        that.is_hide_icon_toggle_scanner_modal = false
                    },
                })
                .modal(value)
        },
        toggle_date_picker_modal(value = "toggle") {
            var that = this
            $('.ui.modal.datetimerange')
                .modal({
                    closable: false,
                    autofocus: false,
                    onShow() {
                        that.is_hide_icon_toggle_scanner_modal = true
                        $('.ui.dimmer.modals').css("background", "rgba(0,0,0,0.85)")
                    },
                    onHidden() {
                        that.is_hide_icon_toggle_scanner_modal = false
                    },
                })
                .modal(value)
        },
        get_current_position() {
            // TODO: TEST
            // this.$store.dispatch('provider/set_current_position', {
            //     is_first_initialized: true,
            //     status: "success",
            //     messages: "",
            //     latitude: 23.265622,
            //     longitude:120.122775,
            //     address: {},
            // })

            try {
                if (!navigator.geolocation) {
                    // throw "你當前瀏覽器不支持存取定位功能"
                    throw this.$t('ui.toolbox.stations_modal.errors.geolocation_is_not_supported_by_this_browser')
                }
                if (location.protocol == 'http:') {
                    // throw "請使用HTTPS服務存取"
                    throw this.$t('ui.toolbox.stations_modal.errors.your_web_protocol_is_not_HTTPS')
                }

                navigator.geolocation.getCurrentPosition((position) => {
                    if (position.coords.latitude) {
                        this.$store.dispatch('provider/set_current_position', {
                            is_first_initialized: true,
                            status: "success",
                            messages: "",
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                            address: {},
                        })
                        console.log(position.coords)
                    } else {
                        // throw "取得 定位功能失敗"
                        throw this.$t('ui.toolbox.stations_modal.errors.get_location_failure')
                    }
                })

            } catch (err) {
                this.$noty.error(err)
                this.$store.dispatch('provider/set_current_position', {
                    status: "failure",
                    messages: err,
                    latitude: "",
                    longitude: "",
                    address: {},
                })
                return Promise.reject(err)
            }
        },
        /**
         * This function is check can use print waybill
         * Return {
         *   status: String(success || failure),
         *   error: String
         * }
         *
         * Parameter help
         *   core_waybill_number: 號碼,
         *   max_diff_second: 重複號碼秒數上限, 預設60s,
         *   max_length: 最多號碼數量, 預設10筆,
         *
         * @Auth Eziopu <eziopu@mynet.com.tw>
         * @Edit Date 2018-01-08
         */
        is_print_waybill(
            core_waybill_number,
            max_diff_second = 60,
            max_length = 10
        ) {
            /* localStorage use Array JSON
                [{
                    "number": 123,
                    "created_at": "2018/xx/xx xx:xx:xx"
                },{
                    "number": 456,
                    "created_at": "2018/xx/xx xx:xx:xx"
                },{...}]
            */
            var result = {
                "status": "failure",
                "error": ""
            }
            var print_waybills = []
            var print_waybill_history = localStorage.getItem('print_waybill_history')

            // 第一次存 localStorage
            if (!print_waybill_history) {
                this.set_print_waybill_history(
                    print_waybills, core_waybill_number
                )
                result.status = "success"

            } else {
                // is String to Array Json
                print_waybills = $.parseJSON('[' + print_waybill_history + ']')

                // 存在於 localStorage 的core_waybill
                var current_core_waybill = _.find(print_waybills, (print_waybill) => {
                    return print_waybill.number == core_waybill_number
                })

                // 存在 localStorage 內
                if (current_core_waybill) {
                    // 比較時間
                    var created_at = this.$moment(current_core_waybill.created_at)
                    var diff_result = this.$moment().diff(created_at, 'second')

                    // 大於 連續產標時間 可放入 localStorage 內
                    if (diff_result > max_diff_second) {
                        // 刪除 當前 localStorage 內的 core_waybill
                        _.remove(print_waybills, (object) => {
                            return object.number == core_waybill_number
                        })

                        this.set_print_waybill_history(
                            print_waybills, core_waybill_number
                        )
                        result.status = "success"

                    } else {
                        result.status = "failure"
                        result.error = "您無法在"+max_diff_second+"秒內 連續印標"
                    }

                // 不存在 localStorage 內
                } else {
                    this.set_print_waybill_history(
                        print_waybills, core_waybill_number
                    )
                    result.status = "success"
                }

                // 大於
                if (print_waybills.length > max_length) {
                    // 刪除最舊一筆
                    print_waybills.shift()
                    this.set_print_waybill_history(print_waybills)
                }
            }
            console.log(
                'print_waybill_history',
                localStorage.getItem('print_waybill_history')
            )
            return result
        },
        set_print_waybill_history(results, core_waybill_number = "") {
            /* results 範例
                [{
                    "number": 123,
                    "created_at": "2017/xx/xx xx:xx:xx"
                },{...}]
            */
            if (core_waybill_number) {
                results.push({
                    "number": core_waybill_number,
                    "created_at": this.$moment().format('YYYY/MM/DD HH:mm:ss')
                })
            }

            var new_array = []
            _.forEach(results, (result) => {
                new_array.push(
                    JSON.stringify(result)
                )
            })

            localStorage.setItem('print_waybill_history',
                new_array.toString()
            )
        },
        /*
         * 處理在store無法切換i18n的文字
        **/
        cahnge_language_in_store_js_text() {
            // element_ui 時間範圍選擇
            _.map(this.$store.state.element_ui_datepicker_daterange_options.shortcuts, (shortcut) => {
                shortcut.text = this.$t(shortcut.i18n_key)
            })
        },
    },
    components: {
        Login,
        Sidebar,
        TopMenu,
        FooterBar,
        Advertising,
        SystemInfo,
        Breadcrumb,
        ScannerModal,
        StationsModal,
        DatetimerangeModal,
    },
}
</script>
<style lang="scss">
@import "../../assets/stylesheets/fonts.scss";
@import "../../assets/stylesheets/layout.scss";
.ui.items>.item>.content>.description {
    overflow: auto;
}
@media only screen and (max-width: 843px) {
    #provider .ui.fluid.container {
        padding: 0px !important;
        margin-left: 0.5em!important;
        margin-right: 0.5em!important;
    }
}
#provider .ui.fluid.container {
    padding: 0 15px;
}

#webcam {
    position: absolute;
    z-index: 1000;
    top: 5%;
    right: 5%;
}
.loading_mock {
    max-width: 100%;
}
.opacity_fade {
    -webkit-animation: opacity_fade 2s infinite;
    animation: opacity_fade 2s infinite;
}
.mobile.icon_toggle_scanner_modal {
    position: fixed;
    z-index: 8080;
    bottom: 18px;
    right: 6px;
}

@-webkit-keyframes opacity_fade {
    0% {opacity: 0.5;}
    50% {opacity: 0.3;}
    100% {opacity: 0.5;}
}

@keyframes opacity_fade {
    0% {opacity: 0.5;}
    50% {opacity: 0.3;}
    100% {opacity: 0.5;}
}
</style>
